/* Sockologie Wishlist
   ===================
   - Guests: list lives in localStorage (instant, no login).
   - Logged in: list syncs to the server via the Shopify App Proxy
     (/apps/subscription/wishlist/*), which is HMAC-signed by Shopify and
     carries the verified customer id. On login we merge the guest list up.
   - Product-level (one entry per product).

   Exposes window.skWishlist for the wishlist page + other UI.
   Fires a `sk:wishlist:change` event on document whenever the list changes.
*/
(function () {
  if (window.skWishlist) return;

  var STORAGE_KEY = 'sk_wishlist';
  var PROXY = '/apps/subscription/wishlist';
  var loggedIn = !!(window.__sk && window.__sk.loggedIn);

  // ---- storage ----
  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      // normalize to {id, handle}
      return arr
        .map(function (it) {
          if (it && typeof it === 'object') {
            return { id: String(it.id || it.product_id || ''), handle: String(it.handle || it.product_handle || '') };
          }
          return { id: String(it), handle: '' };
        })
        .filter(function (it) { return it.id; });
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  var items = read();

  function has(id) {
    id = String(id);
    return items.some(function (it) { return it.id === id; });
  }

  function emitChange() {
    write(items);
    renderAll();
    try {
      document.dispatchEvent(new CustomEvent('sk:wishlist:change', { detail: { items: items.slice() } }));
    } catch (e) {}
  }

  // ---- server sync (logged-in only) ----
  function serverCall(action, payload) {
    var url = PROXY + '/' + action;
    var opts = {
      method: action === 'list' ? 'GET' : 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    };
    if (action !== 'list') {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(payload || {});
    }
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('wishlist ' + action + ' failed: ' + r.status);
      return r.json();
    });
  }

  // On login: push the guest list up and pull the authoritative union back.
  function syncOnLoad() {
    if (!loggedIn) return;
    serverCall('merge', { items: items })
      .then(function (res) {
        if (res && res.success && Array.isArray(res.items)) {
          items = res.items.map(function (it) {
            return { id: String(it.product_id || it.id || ''), handle: String(it.product_handle || it.handle || '') };
          }).filter(function (it) { return it.id; });
          emitChange();
        }
      })
      .catch(function (e) { /* offline / not-yet-deployed: stay on localStorage */ });
  }

  // ---- public API ----
  function add(id, handle) {
    id = String(id);
    if (!id || has(id)) return;
    items.unshift({ id: id, handle: handle ? String(handle) : '' });
    emitChange();
    if (loggedIn) serverCall('add', { product_id: id, product_handle: handle || '' }).catch(function () {});
  }

  function remove(id) {
    id = String(id);
    items = items.filter(function (it) { return it.id !== id; });
    emitChange();
    if (loggedIn) serverCall('remove', { product_id: id }).catch(function () {});
  }

  function toggle(id, handle) {
    if (has(id)) { remove(id); return false; }
    add(id, handle); return true;
  }

  // ---- DOM rendering ----
  function renderHearts(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('[data-wishlist-toggle]');
    if (root && root.matches && root.matches('[data-wishlist-toggle]')) btns = [root].concat([].slice.call(btns));
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var saved = has(btn.getAttribute('data-product-id'));
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
      // PDP button has add/saved text labels
      var addLbl = btn.querySelector('[data-wishlist-label-add]');
      var savedLbl = btn.querySelector('[data-wishlist-label-saved]');
      if (addLbl) addLbl.hidden = saved;
      if (savedLbl) savedLbl.hidden = !saved;
    }
  }

  function renderCount() {
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = items.length;
      els[i].classList.toggle('is-empty', items.length === 0);
      els[i].hidden = items.length === 0;
    }
  }

  function renderAll() {
    renderHearts();
    renderCount();
  }

  // ---- click handling (event delegation) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    if (!id) return;
    var nowSaved = toggle(id, handle);
    if (nowSaved) {
      btn.classList.add('is-animating');
      setTimeout(function () { btn.classList.remove('is-animating'); }, 300);
    }
  });

  // Re-render hearts when product cards are injected later (carousels, quick-add, infinite scroll)
  var mo;
  function startObserver() {
    if (mo || !window.MutationObserver) return;
    // SK perf: render only the hearts inside the ADDED nodes. A document-wide
    // re-render on every body insertion (pixels insert hidden inputs too) wrote
    // 3 attributes on every heart on the page per mutation batch.
    mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1 || !n.querySelectorAll) continue;
          renderHearts(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.skWishlist = {
    getItems: function () { return items.slice(); },
    isSaved: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: function () { return items.length; },
    refresh: renderAll
  };

  function init() {
    renderAll();
    startObserver();
    syncOnLoad();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
